import { render, staticRenderFns } from "./content_title.vue?vue&type=template&id=2d65b30d&scoped=true&"
import script from "./content_title.vue?vue&type=script&lang=js&"
export * from "./content_title.vue?vue&type=script&lang=js&"
import style0 from "./content_title.vue?vue&type=style&index=0&id=2d65b30d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65b30d",
  null
  
)

export default component.exports